import { apiClient } from './client'
import { ApiError } from './errors'

export async function requestWithdrawal(data: {
  amount: number
  bankAccountId: number
  // One per withdrawal attempt, re-sent when that attempt is retried, so the API
  // replays the first answer instead of paying out twice. Without it the axios
  // interceptor makes a fresh key for every request.
  idempotencyKey?: string
}): Promise<{ id: number }> {
  try {
    const response = await apiClient.post<{ id: number }>(
      'withdrawals',
      {
        amount: data.amount,
        bank_account_id: data.bankAccountId
      },
      data.idempotencyKey
        ? { headers: { 'Idempotency-Key': data.idempotencyKey } }
        : undefined
    )
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function fetchWithdrawalHistory(): Promise<
  Array<{ id: number; amount: number; status: string; createdAt: string }>
> {
  try {
    const response = await apiClient.get<
      Array<{ id: number; amount: number; status: string; createdAt: string }>
    >('withdrawals/history')
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}
